export class DetailsViewModel<T> {
    private _onSet: VoidFunction;
    public loadingData: KnockoutObservable<boolean>;
    public content: KnockoutObservable<T | null | undefined> = ko.observable();
    public hasContent: KnockoutObservable<boolean> = ko.observable(false);
    public refresh(): void {
        this.content(null);
        this.load();
    };

    public load(): void {
        if (this.content() == null) {
            this.loadingData(true);
            this._onSet();
        }
    };

    public setContent(json: T): void {
        this.content(json);
    };

    constructor(onSet: VoidFunction, isLoading: boolean = true) {
        this.loadingData = ko.observable(isLoading);
        this._onSet = onSet;
        this.content.subscribe((newData) => {
            this.hasContent(false);
            if (newData !== null) {
                this.hasContent(true)
            }
        });
    }
}
